import { GoPencil } from "react-icons/go";
import { IFavoriteInfoType } from "../types/favorite_types";

interface FavoriteEditButtonProps {
  showEditDialog: (message: string) => void;
  favoriteInfo: IFavoriteInfoType;
  setFavoriteInfo: React.Dispatch<React.SetStateAction<IFavoriteInfoType>>;
}

export const FavoriteEditButton: React.FC<FavoriteEditButtonProps> = ({
  showEditDialog,
  favoriteInfo,
  setFavoriteInfo,
}) => {
  const handleOnEditButton = () => {
    setFavoriteInfo(favoriteInfo);
    showEditDialog(favoriteInfo.title);
  };
  return (
    <div>
      <button
        className="absolute right-0 bottom-0 overflow-visible p-1"
        onClick={handleOnEditButton}
      >
        <GoPencil size={"1.25rem"} />
      </button>
    </div>
  );
};
